/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default Fragment.extend({
  accountEmail: attr('string'),
  hasIntegratedProvider: attr('boolean'),
});
